import { useEffect, useState } from 'react'
import { SidebarImport } from './Import'
import * as Icons from 'lucide-react'
const { PerfectScrollbar, logo, Menu, Link, ConfigProvider, Drawer, useNavigate, useLocation, useDispatch, useSelector, sidebar, SessionManager } = SidebarImport

export default function Sidebar(props) {

    const { collapsed, setCollapsed, drawerOpen, setDrawerOpen, isMobileOrTablet } = props

    const [loading, setLoading] = useState(true)
    const [stateOpenKeys, setStateOpenKeys] = useState(['0'])
    const [selectedKeys, setSelectedKeys] = useState([])
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state?.sidebar?.data)
    // console.log(data?.Permissions)

    const DynamicIcon = ({ iconName, ...props }) => {
        const IconComponent = Icons[iconName];

        if (!IconComponent) {
            // Handle cases where the icon name doesn't exist
            return <span>Icon not found</span>;
        }

        return <IconComponent {...props} />;
    }

    const item = data?.Permissions?.map((parent, p_index) => (
        {
            key: p_index.toString(),
            icon: <DynamicIcon iconName={parent.icon} size={18} />,
            label: parent?.module_name,
            children: parent?.masterAction?.map((child, c_index) =>
                child?.permissionAttributes?.action_attributes && JSON.parse(child?.permissionAttributes?.action_attributes)
                    .filter(fil => fil.show_in_menu === true)
                    .map((action, a_index) => (
                        {
                            key: p_index.toString() + c_index.toString() + a_index.toString(),
                            icon: <DynamicIcon iconName={'CircleDot'} size={16} />,
                            label: <Link to={action?.route}>{action?.sub_action_name}</Link>,
                        }
                    )
                    )).flat()
        }
    ))

    const getLevelKeys = (items1) => {
        const key = {};
        const func = (items2, level = 1) => {
            items2?.forEach((item) => {
                if (item?.key) {
                    key[item.key] = level;
                }
                if (item?.children) {
                    func(item.children, level + 1);
                }
            });
        };
        func(items1);
        return key;
    };

    const levelKeys = getLevelKeys(item);

    const onOpenChange = (openKeys) => {
        const currentOpenKey = openKeys.find((key) => stateOpenKeys.indexOf(key) === -1);
        // open
        if (currentOpenKey !== undefined) {
            const repeatIndex = openKeys
                .filter((key) => key !== currentOpenKey)
                .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
            setStateOpenKeys(
                openKeys
                    // remove repeat key
                    .filter((_, index) => index !== repeatIndex)
                    // remove current level all child
                    .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey]),
            );
        } else {
            // close
            setStateOpenKeys(openKeys);
        }
    };

    const sidebar_res = (res) => {
        if (res && res.status === 200) {
            setLoading(false)
            const permission = res?.data?.data?.attributes?.map(val => JSON.parse(val)).flat()
            SessionManager.setSession('permission', JSON.stringify(permission))
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(sidebar({ navigate })).then((res) => sidebar_res(res.payload))
    }, [])

    useEffect(() => {
        // Derive selected and open keys from current URL
        const pathName = location?.pathname || ''
        let computedSelectedKey = null
        let computedOpenKey = null

        item?.forEach((parent) => {
            parent?.children?.forEach((child) => {
                const route = child?.label?.props?.to
                if (!route) return
                if (pathName === route || pathName.startsWith(route + '/')) {
                    computedSelectedKey = child?.key
                    computedOpenKey = parent?.key
                }
            })
        })

        if (computedSelectedKey) {
            setSelectedKeys([computedSelectedKey])
        }
        if (computedOpenKey) {
            setStateOpenKeys([computedOpenKey])
        }
    }, [location?.pathname, data])

    return (
        <>
            {!isMobileOrTablet && (
                <div className={collapsed ? 'sidebar_collapsed' : 'sidebar_notCollapsed'}>

                    <div className='sidebar_header'>
                        <img src={logo} className='img-fluid' alt="logo" />
                    </div>

                    <ConfigProvider
                        theme={{
                            components: {
                                Menu: {
                                    itemSelectedColor: '#ffffff',
                                    subMenuItemSelectedColor: '#ff5040',
                                    itemBg: '#222124',
                                    itemHoverBg: '#444444',
                                    itemHoverColor: '#ffffff',
                                    itemSelectedBg: '#ff5040',
                                    itemColor: '#F8F9FA',
                                    popupBg: '#222124'
                                },
                            },
                            token: {
                                fontFamily: 'Lexend Deca',
                            },
                        }}
                    >
                        <PerfectScrollbar style={{
                            background: '#222124',
                            // borderRight: '1.5px solid #222124',
                            overflow: 'auto',
                            height: '100vh',
                            position: 'relative',
                            insetInlineStart: 0,
                        }}>
                            <Menu
                                mode="inline"
                                inlineCollapsed={collapsed}
                                selectedKeys={selectedKeys}
                                openKeys={stateOpenKeys}
                                onOpenChange={onOpenChange}
                                items={item}
                                style={{ backgroundColor: '#222124' }}
                            />
                        </PerfectScrollbar>
                    </ConfigProvider>
                </div>
            )}

            {isMobileOrTablet && (
                <Drawer
                    title={<img src={logo} className='img-fluid' alt="logo" style={{ height: 32 }} />}
                    placement="left"
                    closable
                    onClose={() => setDrawerOpen(false)}
                    open={drawerOpen}
                    zIndex={2000}
                    styles={{
                        body: { padding: 0, background: "#222124" },
                        header: { background: "#222124" },  // optional
                        footer: { background: "#222124" }   // optional
                    }}
                >
                    <ConfigProvider
                        theme={{
                            components: {
                                Menu: {
                                    itemSelectedColor: '#ffffff',
                                    subMenuItemSelectedColor: '#ff5040',
                                    itemBg: '#222124',
                                    itemHoverBg: '#444444',
                                    itemHoverColor: '#ffffff',
                                    itemSelectedBg: '#ff5040',
                                    itemColor: '#F8F9FA',
                                    popupBg: '#222124'
                                },
                            },
                            token: {
                                fontFamily: 'Lexend Deca',
                            },
                        }}
                    >
                        <Menu
                            mode="inline"
                            selectedKeys={selectedKeys}
                            openKeys={stateOpenKeys}
                            onOpenChange={onOpenChange}
                            items={item}
                            style={{ backgroundColor: '#222124' }}
                        />
                    </ConfigProvider>
                </Drawer>
            )}
        </>
    )
}